'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var SubscriptionModalLayout = require('modules/settings/views/layout/subscription/modal');

var templateDisplay = require('modules/settings/templates/partials/subscription/tax-country-display.hbs');
var templateEdit = require('modules/settings/templates/partials/subscription/tax-country-edit.hbs');

var SubscriptionDeclareTaxCountryView = ItemView.extend({
    getTemplate: function() {
        return this.getOption('mode') === 'edit' ? templateEdit : templateDisplay;
    },

    className: function() {
        return this.getOption('mode') === 'edit' ? 'subscription-tax-country-edit' : 'subscription-tax-country-display';
    },

    ui: {
        form: 'form',
        countrySelect: '[name="subscription-residencyCountry"]',
        confirmCheckbox: '[name="subscription-confirmResidencyCountry"]',
        confirmLabel: '[for="subscription-confirmResidencyCountry"]',
        editButton: '[data-action="edit"]',
        saveButton: '[type="submit"]',
    },

    events: {
        'submit @ui.form': 'onSubmit',
        'click @ui.editButton': 'openEditModal',
        'change @ui.countrySelect': 'updateInputLabel',
        'change @ui.confirmCheckbox': 'validate',
    },

    isSetup: false,

    mode: 'display',

    viewData: {
        countryCollection: function() {
            return App.radio().request('countries:collection');
        },
    },

    onRender: function() {
        ItemView.prototype.onRender.apply(this, arguments);

        this.updateInputLabel();
    },

    onSubmit: function(event) {
        if (event) {
            event.preventDefault();
        }

        // Show loading
        this.triggerMethod('saving');

        this.model.save(this.getData(), {
            patch: true,
            wait: true,
            success: function() {
                this.triggerMethod('saved', this.getData());
            }.bind(this),
            error: function(model, response) {
                this.triggerMethod('save:error', response);
            }.bind(this),
        });
    },

    onSaving: function() {
        if (this.getOption('isSetup') !== true) {
            this.ui.saveButton.prop('disabled', true).addClass('is-loading');
        }
    },

    getData: function() {
        return {
            setupStep: this.getOption('isSetup') ? this.model.get('setupStep') + 1 : this.model.get('setupStep'),
            residencyCountry: this.$('[name="subscription-residencyCountry"]').val(),
        };
    },

    openEditModal: function(event) {
        App.addModal(new SubscriptionModalLayout({
            title: App.t('subscription::setup:tax:modal:title'),
            bodyView: new SubscriptionDeclareTaxCountryView({
                mode: 'edit',
                model: this.model,
            }),
        }), {
            additionalClassName: 'modal-subscription ' + (this.getOption('isSetup') ? 'modal-subscription-setup' : ''),
        });
    },

    validate: function() {
        if (this.ui.confirmCheckbox.prop('checked')) {
            this.triggerMethod('readyToSave');
        } else {
            this.triggerMethod('revokeReadyToSave');
        }

        if (this.getOption('isSetup') !== true) {
            this.ui.saveButton.prop('disabled', !this.ui.confirmCheckbox.prop('checked'));
        }
    },

    updateInputLabel: function() {
        var countryLabel = this.getCountryLabel(this.ui.countrySelect.val());

        if (countryLabel) {
            this.ui.confirmLabel.text(App.t('subscription::payment:label:self-declare-country-of-residency', {residencyCountry: countryLabel}));
            this.ui.confirmLabel.show();
            this.ui.confirmCheckbox.show();
        } else {
            this.ui.confirmLabel.hide();
            this.ui.confirmCheckbox.hide();
        }
    },

    getCountryLabel: function(countryKey) {
        if (countryKey) {
            var country = App.radio().request('countries:collection').get(countryKey);
            if (country) {
                return country.get('name');
            }
        }

        return null;
    },

    onSaveError: function(response) {
        if (this.getOption('isSetup') !== true) {
            this.ui.saveButton.prop('disabled', false).removeClass('is-loading');
        }
    },
});

module.exports = SubscriptionDeclareTaxCountryView;